import { SectionHeader } from "~/components/ui/SectionHeader";
import type {
  SocialType,
  SocialInfo,
  SidebarSocialRowsProps,
  SidebarSocialItemProps,
} from "./types";

export const SOCIAL_DATA: Record<SocialType, SocialInfo> = {
  facebook: {
    url: "https://www.facebook.com/superguidatv",
    buttonLabel: "MI PIACE",
    counterInfo: "Fans",
  },
  instagram: {
    url: "https://www.instagram.com/superguidatv/",
    buttonLabel: "SEGUI",
    counterInfo: "Follower",
  },
  twitter: {
    url: "https://twitter.com/SuperGuidaTV",
    buttonLabel: "SEGUI",
    counterInfo: "Follower",
  },
  youtube: {
    url: "https://www.youtube.com/channel/UCwxgG2su4J3v5l9zHUmwAVg",
    buttonLabel: "ISCRIVITI",
    counterInfo: "Iscritti",
  },
  tiktok: {
    url: "https://www.tiktok.com/@superguidatv",
    buttonLabel: "SEGUI",
    counterInfo: "Follower",
  },
};

const SidebarSocialItem = ({ social, counter }: SidebarSocialItemProps) => {
  return (
    <a
      href={SOCIAL_DATA[social].url}
      class={[
        "sgtv-flex sgtv-w-full sgtv-flex-row sgtv-items-center sgtv-font-open-sans sgtv-text-xs sgtv-font-bold sgtv-text-white hover:sgtv-bg-[#222]",
        social === "facebook" ? "sgtv-bg-[#516eab]" : "",
        social === "instagram" ? "sgtv-bg-[#417096]" : "",
        social === "twitter" ? "sgtv-bg-[#28c5f6]" : "",
        social === "youtube" ? "sgtv-bg-[#e14e42]" : "",
        social === "tiktok" ? "sgtv-bg-[#080808] hover:sgtv-bg-[#383838]" : "",
      ]}
      target="_blank"
      rel="nofollow"
    >
      <div
        class={[
          "sgtv-h-8 sgtv-w-8 sgtv-bg-no-repeat",
          social === "facebook"
            ? "sgtv-bg-[url('/src/assets/social_icons.webp')] sgtv-bg-[length:90px_2100px] sgtv-bg-[-20px_-20px] 2x-pixel-ratio:sgtv-bg-[url('/src/assets/social_icons@2x.png')]"
            : "",
          social === "instagram"
            ? "sgtv-bg-[url('/src/assets/social_icons.webp')] sgtv-bg-[length:90px_2100px] sgtv-bg-[-20px_-228px] 2x-pixel-ratio:sgtv-bg-[url('/src/assets/social_icons@2x.png')]"
            : "",
          social === "twitter"
            ? "sgtv-bg-[url('/src/assets/social_icons.webp')] sgtv-bg-[length:90px_2100px] sgtv-bg-[-20px_-436px] 2x-pixel-ratio:sgtv-bg-[url('/src/assets/social_icons@2x.png')]"
            : "",
          social === "youtube"
            ? "sgtv-bg-[url('/src/assets/social_icons.webp')] sgtv-bg-[length:90px_2100px] sgtv-bg-[-20px_-384px] 2x-pixel-ratio:sgtv-bg-[url('/src/assets/social_icons@2x.png')]"
            : "",
          social === "tiktok"
            ? "sgtv-bg-[url('/src/assets/tiktok_logo.png')] sgtv-bg-[length:16px_16px] sgtv-bg-center 2x-pixel-ratio:sgtv-bg-[url('/src/assets/tiktok_logo.png')]"
            : "",
        ]}
      ></div>
      <p class="before:sgtv-h-4 before:sgtv-border-l before:sgtv-border-white/[.10] before:sgtv-pr-2">
        {counter}
      </p>
      <p class="sgtv-grow sgtv-pl-2 md:sgtv-hidden xl:sgtv-block">
        {SOCIAL_DATA[social].counterInfo}
      </p>
      <p class="sgtv-pr-4 before:sgtv-h-4 before:sgtv-border-l before:sgtv-border-white/[.10] before:sgtv-pr-2 md:sgtv-ml-auto xl:sgtv-ml-0">
        {SOCIAL_DATA[social].buttonLabel}
      </p>
    </a>
  );
};

export const SidebarSocialRows = ({
  counters,
  class: className,
}: SidebarSocialRowsProps) => {
  return (
    <div class="sgtv-flex sgtv-flex-col sgtv-gap-6">
      <SectionHeader as="span" label="Seguici sui social" />
      <div class={["sgtv-space-y-2.5", className]}>
        <SidebarSocialItem social="facebook" counter={counters.facebook} />
        <SidebarSocialItem social="instagram" counter={counters.instagram} />
        <SidebarSocialItem social="twitter" counter={counters.twitter} />
        {typeof counters.youtube === "string" ? (
          <SidebarSocialItem social="youtube" counter={counters.youtube} />
        ) : null}
        {typeof counters.tiktok === "string" ? (
          <SidebarSocialItem social="tiktok" counter={counters.tiktok} />
        ) : null}
      </div>
    </div>
  );
};
